import React from 'react';
import PropTypes from 'prop-types';
import Picker from 'emoji-picker-react';
import Popover from '@material-ui/core/Popover';


export default function EmojiPickerDialog(props) {
  const { onClose, onEmojiSelected, open } = props;

  return (
    <Popover
      open={open}
      anchorEl={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Picker
        onEmojiClick={onEmojiSelected}
        disableAutoFocus
      />
    </Popover>
  );
}

EmojiPickerDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onEmojiSelected: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/main/socialwall/emoji-picker.js